"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function is(obj, type) {
    if (obj === null || obj === undefined) {
        return obj === type;
    }
    return obj.constructor === type;
}
exports.is = is;
